import { ArrivalWindow } from './arrivalWindow.enum'

/**
 * return the starting hour of an arrival window
 */
export const getArrivalWindowDepartureTime = (
  arrivalWindow: ArrivalWindow | string,
) => {
  switch (arrivalWindow) {
    case ArrivalWindow.from7to8:
      return 7
    case ArrivalWindow.from8to9:
      return 8
    case ArrivalWindow.from9to10:
      return 9
    case ArrivalWindow.from13to15:
      return 13
    case ArrivalWindow.from16to19:
      return 16
    default:
      return 8 // todo : handle custom temporal time
  }
}
